



















































































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import ZenButton from '@reciprocity/button';
import { VBTooltip } from 'bootstrap-vue';

import LoadingSpinner from '@reciprocity/loading-spinner';
import HelpLink from '@/components/help_link/HelpLink';
import StepNavigation from '@/components/step_navigation/StepNavigation.vue';

import AllSteps from './steps/asw_steps';

export default Vue.extend({
  name: 'AuditSetupWizard',
  components: {
    ...AllSteps,
    ZenButton,
    StepNavigation,
    LoadingSpinner,
    HelpLink,
  },
  directives: {
    BTooltip: VBTooltip,
  },
  computed: {
    ...mapGetters('auditSetupWizard', [
      'isLoading',
      'isSaving',
      'controlsDisabled',
      'getAuditId',
      'getAuditStatus',
      'getAudit',
      'currentStep',
      'hasPreviousStep',
      'hasNextStep',
      'getStepInfo',
      'isNewAuditValid',
      'isRequestMapperVisible',
      'showMapperButton',
      'isManagedInZenGRC',
      'isManagedInExternalSystem',
      'isManagedInServiceNow',
    ]),
    mapperButtonCopy(): string {
      const showMapper = this.isManagedInZenGRC || this.isManagedInExternalSystem;
      return this.isRequestMapperVisible ? '+ Add more Requests' : showMapper ? 'Show Mapper' : 'Show Request list';
    },
    tooltipHelpText(): string {
      if (this.isManagedInServiceNow) {
        return 'By clicking Save, the Audit will be created as Visual Task Board in ServiceNow.';
      }
      return '';
    },
  },
  created() {
    this.setPageTitle({ title: 'Audit Setup Wizard', visible: false });
    this.loadWizard();
  },
  methods: {
    ...mapActions(['setPageTitle', 'csrfToken']),
    ...mapActions('auditSetupWizard', [
      'loadWizard',
      'saveAndClose',
      'setStep',
      'goToPreviousStep',
      'goToNextStep',
      'startAudit',
      'toggleRequestMapper',
      'saveAssessmentTemplate',
      'loadAudit',
    ]),
    toggleMapper() {
      this.toggleRequestMapper();
    },
  },
});
